<form #form="ngForm">
    <ng-container *ngIf="benefitDetail">
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>Subcategory</mat-label>
                <mat-select
                    name="benefitType"
                    #benefitType="ngModel"
                    [(ngModel)]="benefitDetail.benefitType"
                    [compareWith]="isSameModel"
                >
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngFor="let type of benefitTypes" [value]="type">{{ type.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>Coverage</mat-label>
                <input
                    matInput
                    type="number"
                    #coverage="ngModel"
                    name="coverage"
                    [(ngModel)]="benefitDetail.coverage"
                />
                <mat-icon matSuffix svgIcon="percent"></mat-icon>
                <mat-error *ngIf="coverage.invalid">{{ coverage.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>Amount</mat-label>
                <input
                    matInput
                    type="number"
                    #reimbursement="ngModel"
                    name="reimbursement"
                    [(ngModel)]="benefitDetail.reimbursement"
                />
                <mat-icon matSuffix svgIcon="dollar"></mat-icon>
                <mat-error *ngIf="reimbursement.invalid">{{ reimbursement.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>Deductible</mat-label>
                <input
                    matInput
                    type="number"
                    #deductible="ngModel"
                    name="deductible"
                    [(ngModel)]="benefitDetail.deductible"
                />
                <mat-error *ngIf="deductible.invalid">{{ deductible.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>Maximum</mat-label>
                <input matInput type="number" #max="ngModel" name="max" [(ngModel)]="benefitDetail.max" />
                <mat-error *ngIf="max.invalid">{{ max.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>Non-evidence maximum</mat-label>
                <input matInput type="number" #nem="ngModel" name="nem" [(ngModel)]="benefitDetail.nem" />
                <mat-error *ngIf="nem.invalid">{{ nem.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div>
            <app-segment-header title="Optional Settings" [collapsible]="true" [collapsed]="true"></app-segment-header>
            <div class="content">
                <div class="app-grid">
                    <mat-form-field class="columns-12">
                        <mat-label>Description</mat-label>
                        <textarea
                            matInput
                            name="description"
                            #description="ngModel"
                            rows="3"
                            [(ngModel)]="benefitDetail.description"
                            placeholder="e.g. Employee Benefits"
                        ></textarea>
                        <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </ng-container>
</form>
